import React from 'react'

import { AcornsIcon } from '@acorns/icons'

import { PERFORMANCE_TOGGLE } from 'utils/testing/testIDs'

import {
  IconWrapper,
  ToggleArrowWrapper,
  ToggleTab,
  ToggleTabWrapper,
} from './styled-components'

const ArrowToggle = ({
  isMarket,
  onClickMarket,
}: {
  isMarket: boolean
  onClickMarket: (value: boolean) => void
}): React.ReactElement => {
  return (
    <div data-testid={PERFORMANCE_TOGGLE}>
      <ToggleArrowWrapper>
        <IconWrapper
          aria-label="Show market gain/loss"
          disabled={isMarket}
          onClick={() => onClickMarket(true)}
        >
          <AcornsIcon icon={AcornsIcon.Icon.LeftChevron} width={6} />
        </IconWrapper>
        <IconWrapper
          aria-label="Show total gain/loss"
          disabled={!isMarket}
          onClick={() => onClickMarket(false)}
        >
          <AcornsIcon icon={AcornsIcon.Icon.RightChevron} width={6} />
        </IconWrapper>
      </ToggleArrowWrapper>
      <ToggleTabWrapper>
        <ToggleTab
          aria-label="Toggle to Market gain/loss"
          disabled={isMarket}
          onClick={() => onClickMarket(true)}
        />
        <ToggleTab
          aria-label="Toggle to Total gain/loss"
          disabled={!isMarket}
          onClick={() => onClickMarket(false)}
        />
      </ToggleTabWrapper>
    </div>
  )
}

export { ArrowToggle }
